import React, { useState, useEffect, useRef } from 'react';
import { _Api } from '../api/_call'
import TableColumnModal from '../common/modules/tableColumn'
import { Tablehead } from '../common/modules/Tablehead'
import { inventoryskumovementlisthead } from '../common/Tablehead'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { buildLastMonthDateRange } from '../common/helpers/function';
import SocialModal from '../common/modules/SocialModal/SocialModal'
import { loading, Updateloading } from '../common/helpers/toastify'
import ProductImageSliderModal from '../common/modules/productImageslider'
import Filtermodal from "../common/modules/Filtermodal";
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Pagination } from '../common/Pagination'
import Select from "react-select";
import * as FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import { useSelector } from 'react-redux';
import TableLoader from '../../admin/common/TableLoader';
import './inventory.scss';

const SkuMovement = (props) => {
  const { t } = useTranslation()
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const stickyTopRef = useRef(null);
  const tableHeadScrollRef = useRef(null);
  const tableBodyScrollRef = useRef(null);
  const tableHeadTableRef = useRef(null);
  const tableBodyTableRef = useRef(null);
  const tableScrollSyncLock = useRef(false);
  const [filtername, setFiltername] = useState('')
  const [SelectAllStatus, setSelectAllStatus] = useState()
  const [datefilter, setDatefilter] = useState(() => buildLastMonthDateRange().filter)
  const [datelable, setDatelable] = useState("LastMonth")
  const datePickerRef = useRef(null)
  const changeDates = (lable) => {
    const MainDate = new Date();
    if (lable === "Today") {
      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      setDatefilter([todayStart, new Date()]);
    } else if (lable === "Yesterday") {
      const yesterdayStart = new Date(MainDate.setDate(MainDate.getDate() - 1));
      yesterdayStart.setHours(0, 0, 0, 0);
      const yesterdayEnd = new Date(yesterdayStart);
      yesterdayEnd.setHours(23, 59, 59, 999);
      setDatefilter([yesterdayStart, yesterdayEnd]);
    } else if (lable === "7days") {
      const sevendays = new Date(MainDate.setDate(MainDate.getDate() - 7));
      sevendays.setHours(0, 0, 0, 0);
      const todayEnd = new Date();
      todayEnd.setHours(23, 59, 59, 999);
      setDatefilter([sevendays, todayEnd]);
    } else if (lable === "30days") {
      const days = new Date(MainDate.setDate(MainDate.getDate() - 30));
      days.setHours(0, 0, 0, 0);
      const todayEnd = new Date();
      todayEnd.setHours(23, 59, 59, 999);
      setDatefilter([days, todayEnd]);
    } else if (lable === "ThisMonth") {
      const firstDay = new Date(MainDate.getFullYear(), MainDate.getMonth(), 1);
      firstDay.setHours(0, 0, 0, 0);
      const lastDay = new Date(MainDate.getFullYear(), MainDate.getMonth() + 1, 0);
      lastDay.setHours(23, 59, 59, 999);
      setDatefilter([firstDay, lastDay]);
    } else if (lable === "LastMonth") {
      setDatefilter(buildLastMonthDateRange().filter);
    }
    setDatelable(lable);
  }
  const [newcolumndata, setnewcolumndata] = useState(inventoryskumovementlisthead)
  const [skumovementlist, setskumovementlist] = useState([])
  const [skumovementcounts, setskumovementcounts] = useState()
  const [shareloader, setShareloader] = useState(false)
  const [socialurl, setSocialurl] = useState()
  const [imageid, setImageid] = useState()
  const [limit, setLimit] = useState("100")
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  const [selecteditem, setSelecteditem] = useState([]);
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const [datalodaer, setDatsLodaer] = useState(false)
  const [filterdata, setFilterdata] = useState()
  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 }
  ]


  const filterbyname = (search) => {
    getskumovement(1, limit, filterdata, search)
    setstate({ ...state, currentPage: 1 })
  }
  const getlimit = (limit) => {
    setLimit(limit)
    getskumovement(1, limit, filterdata, filtername)
    setstate({ ...state, currentPage: 1 })
  }
  const [state, setstate] = useState({
    totalPages: 20,
    currentPage: 1,
  })
  const { totalPages, currentPage } = state
  const handlePaginations = (current) => {
    setstate({ ...state, currentPage: current })
    getskumovement(current, '', filterdata, filtername)
  }
  const getskumovement = async (current, firstlimit, filter, search) => {
    setFilterdata(filter)
    setDatsLodaer(true)
    try {
      const postdata = {
        type: 'SKU',
        metal: filter?.metal ? filter?.metal : [],
        location: filter?.location ? filter?.location : [],
        collection: filter?.collection ? filter?.collection : [],
        item: filter?.item ? filter?.item : [],
        search: search ? search : "",
        size: filter?.size ? filter?.size : [],
        stone: filter?.stone ? filter?.stone : [],
        "start_date": datefilter ? datefilter[0] : "",
        "end_date": datefilter ? datefilter[1] : "",
        limit: firstlimit ? firstlimit : limit,
        skip: current ? (current - 1) * (firstlimit || limit) : 0,
        // SKUMovemnetNew reads `sikp`, not `skip`.
        sikp: current ? (current - 1) * (firstlimit || limit) : 0,
      }
      let resPoinventory = await _Api(
        postdata,
        `api/v1/Inventory/productMovement/SKUMovement`,
      )
      if (resPoinventory?.code === 200) {
        setskumovementlist(resPoinventory?.data)
        setskumovementcounts(resPoinventory?.count)
        setstate({
          ...state,
          totalPages: Math.ceil(resPoinventory?.total / postdata.limit),
          currentPage: current ? current : 1,
        })
        setDatsLodaer(false)
      } else {
        setDatsLodaer(false)
      }
    } catch (err) {
      console.log(err, 'err')
      setDatsLodaer(false)
    }
  }
  const callcolumns = async () => {
    try {
      const postdata = {
        name: 'tbl_sku_movement',
      }
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`,
      )
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data)
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }
  // Loads on mount and reloads from page 1 whenever the date range changes.
  // A custom range is only applied once both dates are picked.
  useEffect(() => {
    if (!datefilter?.[0] || !datefilter?.[1]) return;
    getskumovement(1, limit, filterdata, filtername)
    // eslint-disable-next-line
  }, [datefilter])
  useEffect(() => {
    callcolumns()
  }, [])
  const downloadexclsheet = async () => {
    let header_values = []
    let bodyarray = []
    inventoryskumovementlisthead.map(async (r, k) => {
      header_values.push(r?.lable)
    })
    if (skumovementlist.length) {

      skumovementlist.forEach((result, key) => {
        bodyarray.push([
          key + 1,
          result?.main_image,
          result?.SKU,
          result?.metal_name,
          result?.stone_name,
          result?.size_name,
          result?.item_name,
          result?.collection_name,
          result?.locations,
          result?.aging,
          result?.inward_Qty,
          result?.outward_Qty,
          result?.closing_Qty,
          result?.closing_amount,

        ])
      })
    }
    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.json_to_sheet(bodyarray, {
      origin: 'A2',
      skipHeader: true,
    })
    XLSX.utils.sheet_add_aoa(ws, [header_values], { origin: 'A1' })
    XLSX.utils.book_append_sheet(wb, ws, 'Records')
    const fileContent = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const data = new Blob([fileContent], { type: fileType })
    FileSaver.saveAs(data, 'SKU_MOVEMENT')
  }
  const getsharerstockid = async () => {
    setShareloader(true)
    try {
      const postdata = {
        search: filtername,
        start_date: datefilter ? datefilter[0] : '',
        end_date: datefilter ? datefilter[1] : '',
        product_ids: selecteditem ? selecteditem : [],
      }
      let res = await _Api(
        postdata,
        `api/v1/Inventory/reports/print/productStockCard`,
      )

      if (res.code === 200) {
        setSocialurl(res?.link)
        setShareloader(false)
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }
  const getprintstockid = async () => {
    let GetloadingID = loading()

    try {
      const postdata = {
        search: filtername,
        start_date: datefilter ? datefilter[0] : '',
        end_date: datefilter ? datefilter[1] : '',
        product_ids: selecteditem ? selecteditem : [],
      }
      let res = await _Api(
        postdata,
        `api/v1/Inventory/reports/print/productStockCard`,
      )

      if (res.code === 200) {
        setTimeout(() => {
          const exportLinkElement = document.createElement('a')
          exportLinkElement.hidden = true
          exportLinkElement.download = res?.name ? res?.name : 'report.pdf'
          exportLinkElement.href = res?.link
          exportLinkElement.text = 'downloading...'
          exportLinkElement.setAttribute('target', '_blank')
          document.body.appendChild(exportLinkElement)
          exportLinkElement.click()
          exportLinkElement.remove()
          Updateloading(t, GetloadingID, t('download successfully'))
        }, 50)
        setSocialurl(res?.link)
      } else {
        Updateloading(t, GetloadingID, res?.message ? (res?.message) : (res?.errors), 'error');
      }
    } catch (err) {
      console.log(err, 'err')
      Updateloading(t, GetloadingID, err, t('error'))
    }
  }
  const selectedproduct = (event) => {
    if (event.target.checked) {
      const selected = document.querySelectorAll(
        '.inventoryskumovementtablecheck',
      )
      const mainselected = []
      for (let i = 0; i < selected.length; i++) {
        if (selected[i].checked) {
          let product_id = selected[i].getAttribute('data-id')
          mainselected.push(product_id)
        }
      }
      setSelecteditem(mainselected)
    } else {
      const result = selecteditem.filter((element) => {
        return element !== event.target.value
      })
      setSelecteditem(result)
    }
  }
  useEffect(() => {
    if (SelectAllStatus) {
      const selected = document.querySelectorAll(
        '.inventoryskumovementtablecheck',
      )
      let arrya = []
      for (let i = 0; i < selected.length; i++) {
        if (selected[i].checked) {
          let product_id = selected[i].getAttribute('data-id')
          arrya.push(product_id)
        }
      }
      setSelecteditem(arrya)
    } else {
      setSelecteditem([])
    }
  }, [SelectAllStatus])

  useEffect(() => {
    const el = stickyTopRef.current;
    if (!el) return undefined;
    const page = el.closest(".inventory-sku-page");
    const apply = () => {
      if (!page) return;
      page.style.setProperty(
        "--inventory-sticky-block-height",
        `${el.offsetHeight}px`,
      );
    };
    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(el);
    window.addEventListener("resize", apply);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", apply);
    };
  }, []);

  const syncInventoryTableScroll = (source) => {
    if (tableScrollSyncLock.current) return;
    const head = tableHeadScrollRef.current;
    const body = tableBodyScrollRef.current;
    if (!head || !body) return;
    tableScrollSyncLock.current = true;
    if (source === "head") {
      body.scrollLeft = head.scrollLeft;
    } else {
      head.scrollLeft = body.scrollLeft;
    }
    requestAnimationFrame(() => {
      tableScrollSyncLock.current = false;
    });
  };

  useEffect(() => {
    let frame = 0;
    const syncInventoryTableWidths = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const headTable = tableHeadTableRef.current;
        const bodyTable = tableBodyTableRef.current;
        if (!headTable || !bodyTable) return;

        const headThs = headTable.querySelectorAll("thead th");
        const bodyRow = bodyTable.querySelector("tbody tr");
        const footRow = bodyTable.querySelector("tfoot tr");
        const count = headThs.length;
        if (!count) return;

        headTable.style.width = "max-content";
        bodyTable.style.width = "max-content";
        headTable.style.tableLayout = "auto";
        bodyTable.style.tableLayout = "auto";
        headThs.forEach((th) => {
          th.style.width = "";
          th.style.minWidth = "";
          th.style.maxWidth = "";
        });
        bodyTable.querySelectorAll("td, th").forEach((cell) => {
          cell.style.width = "";
          cell.style.minWidth = "";
          cell.style.maxWidth = "";
        });

        const widths = [];
        for (let i = 0; i < count; i += 1) {
          const hw = headThs[i].getBoundingClientRect().width;
          const bw = bodyRow?.children[i]?.getBoundingClientRect().width || 0;
          const fw = footRow?.children[i]?.getBoundingClientRect().width || 0;
          widths.push(Math.ceil(Math.max(hw, bw, fw, 40)));
        }
        const total = widths.reduce((sum, w) => sum + w, 0);
        headTable.style.tableLayout = "fixed";
        bodyTable.style.tableLayout = "fixed";
        headTable.style.width = `${total}px`;
        bodyTable.style.width = `${total}px`;

        for (let i = 0; i < count; i += 1) {
          const widthPx = `${widths[i]}px`;
          headThs[i].style.width = widthPx;
          headThs[i].style.minWidth = widthPx;
          headThs[i].style.maxWidth = widthPx;
          bodyTable
            .querySelectorAll(`tr > :nth-child(${i + 1})`)
            .forEach((cell) => {
              cell.style.width = widthPx;
              cell.style.minWidth = widthPx;
              cell.style.maxWidth = widthPx;
            });
        }

        (newcolumndata || []).forEach((col, index) => {
          const hide = col?.status === false;
          headThs[index]?.classList.toggle("d-none", hide);
          bodyTable
            .querySelectorAll(`tr > :nth-child(${index + 1})`)
            .forEach((cell) => {
              cell.classList.toggle("d-none", hide);
            });
        });
      });
    };

    syncInventoryTableWidths();
    window.addEventListener("resize", syncInventoryTableWidths);
    const observer = new ResizeObserver(syncInventoryTableWidths);
    if (tableHeadScrollRef.current) observer.observe(tableHeadScrollRef.current);
    if (tableBodyScrollRef.current) observer.observe(tableBodyScrollRef.current);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", syncInventoryTableWidths);
      observer.disconnect();
    };
  }, [skumovementlist, newcolumndata, datalodaer]);

  return (
    <React.Fragment>
      <div className="main-body inventory-sku-page product-tab-page-padding-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12" style={{ display: "flex", flexWrap: "wrap" }}>
              <div className="sticky-top-inventory-page" ref={stickyTopRef}>
              <h2 className="main-body-heading">
                <span>
                  {t('Product Analysis')} {'>'}
                </span>
                {t('Sku Analysis')}
              </h2>
              <div className="main-body-top-inventory">
                <div className="main-body-top-inventory-status">
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + 'images/icons/free-stock.png'}
                        className="inventory-img"
                        alt="free-stock"
                      />
                    </div>
                    <div className="right-side">
                      <span className="inventory-name">{t('Stock')}</span>
                      <h2 className="inventory-value stock">
                        {skumovementcounts?.stocks}
                      </h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + 'images/icons/sku.png'}
                        className="inventory-img"
                        alt="sku"
                      />
                    </div>
                    <div className="right-side">
                      <p className="inventory-name">{t('SKU')}</p>
                      <h2 className="inventory-value sku">
                        {skumovementcounts?.SKU}
                      </h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={base_assets + 'images/icons/location.png'}
                        className="inventory-img"
                        alt="value"
                      />
                    </div>
                    <div className="right-side">
                      <span className="inventory-name">{t('Total Value')}</span>
                      <h2 className="inventory-value location">
                        {skumovementcounts?.amount}
                      </h2>
                    </div>
                  </div>
                  <div className="main-body-top-inventory-status-card">
                    <div className="left-side">
                      <img
                        src={
                          base_assets + 'images/icons/loacation_on_green.png'
                        }
                        className="inventory-img"
                        alt="free-stock"
                      />
                    </div>
                    <div className="right-side">
                      <span className="inventory-name">{t('Locations')}</span>
                      <h2 className="inventory-value location">
                        {skumovementcounts?.location}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="main-body-top-status-bar">
                <Select
                  className="limit-select short"
                  options={selectOptions}
                  value={{ label: limit, value: limit }}
                  onChange={(e) => { setLimit(e.value); getlimit(e.value) }}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
                <div className="main-body-top-status-bar-filter">
                  <button
                    className="main-body-top-status-bar-filter-icon"
                    data-bs-toggle="modal"
                    data-bs-target="#filterinventory"
                  >
                    <img
                      className="d-block"
                      src={base_assets + '/images/icons/search-outline.png'}
                      alt=""
                    />
                  </button>
                  <input
                    type="text"
                    value={filtername}
                    className="main-body-top-status-bar-filter-input"
                    placeholder={t('PO No./Supplier/Ship to ...')}
                    onKeyPress={(e) => e.key === 'Enter' && filterbyname(e.target.value)}
                    onChange={(e) => setFiltername(e.target.value)}
                  />
                  {filtername ? <img className="main-body-top-status-bar-filter-clear" src={base_assets + 'images/icons/False.png'} onClick={(e) => { setFiltername(""); filterbyname("") }} alt="" /> : ""}
                  <button
                    onClick={() => filterbyname(filtername)}
                    className="main-body-top-status-bar-filter-search"
                  >
                    <i className="fa fa-search" aria-hidden="true" />
                  </button>
                </div>
                <div className="main-body-top-status-bar-multi-date-picker">
                  <div className="main-body-top-status-bar-note-button common-dropdown replenish-date">
                    <button
                      className="dropdown-toggle btn-style align-items-center d-flex"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 4.66667V8L10.5 10.5M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      {t(datelable)}
                    </button>
                    <ul className="dropdown-menu dropdown-menu-right-fix">
                      <li className={`dropdown-item ${datelable === "Today" ? "active" : ""}`} onClick={() => changeDates("Today")}>{t("Today")}</li>
                      <li className={`dropdown-item ${datelable === "Yesterday" ? "active" : ""}`} onClick={() => changeDates("Yesterday")}>{t("Yesterday")}</li>
                      <li className={`dropdown-item ${datelable === "7days" ? "active" : ""}`} onClick={() => changeDates("7days")}>{t("Last 7 days")}</li>
                      <li className={`dropdown-item ${datelable === "30days" ? "active" : ""}`} onClick={() => changeDates("30days")}>{t("Last 30 days")}</li>
                      <li className={`dropdown-item ${datelable === "ThisMonth" ? "active" : ""}`} onClick={() => changeDates("ThisMonth")}>{t("This Month")}</li>
                      <li className={`dropdown-item ${datelable === "LastMonth" ? "active" : ""}`} onClick={() => changeDates("LastMonth")}>{t("Last Month")}</li>
                      <li className={`dropdown-item ${datelable === "Custom Range" ? "active" : ""}`} onClick={() => datePickerRef.current.setOpen(true)}>{t("Custom Range")}</li>
                    </ul>
                    <DatePicker
                      selectsRange={true}
                      monthsShown={2}
                      startDate={datefilter[0]}
                      endDate={datefilter[1]}
                      onChange={(update) => {
                        const startDate = update[0];
                        const endDate = update[1];
                        setDatelable("Custom Range");
                        if (startDate && endDate) {
                          const modifiedStartDate = new Date(startDate);
                          modifiedStartDate.setHours(0, 0, 0, 0);
                          const modifiedEndDate = new Date(endDate);
                          modifiedEndDate.setHours(23, 59, 59, 999);
                          setDatefilter([modifiedStartDate, modifiedEndDate]);
                        } else {
                          setDatefilter([startDate, endDate]);
                        }
                      }}
                      dateFormat="yyyy-MM-dd"
                      ref={datePickerRef}
                      autoComplete="none"
                    />
                  </div>
                  <button className="print-export-dropdown-selected-icon d-none">
                    <img
                      src={base_assets + 'images/icons/printer-icon.png'}
                      alt=""
                    />
                  </button>
                  <div className="main-body-top-status-bar-print-export-dropdown dropdown">
                    <button
                      className="btn dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src={base_assets + 'images/icons/ellipsis-circular.png'}
                        alt=""
                      />
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li
                        className={
                          parmissiondatashow?.sku_analysis?.Print
                            ? 'dropdown-item print-dropdown-item'
                            : 'd-none'
                        }
                        onClick={(e) => {
                          getprintstockid()
                        }}
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + 'images/icons/printer-icon.png'}
                            alt=""
                          />
                        </div>
                        <span>{t('print')}</span>
                      </li>
                      <li
                        className="dropdown-item"
                        onClick={() => downloadexclsheet()}
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + 'images/icons/export-x-icon.png'}
                            alt=""
                          />
                        </div>
                        <span>{t('export')}</span>
                      </li>
                      <li
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#socialModal"
                        onClick={() => getsharerstockid()}
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + 'images/icons/share-icon.png'}
                            alt=""
                          />
                        </div>
                        <span>{t('share')}</span>
                      </li>
                      <li
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#columnModal"
                      >
                        <div className="dropdown-item-img">
                          <img
                            src={base_assets + 'images/icons/column-icon.png'}
                            alt=""
                          />
                        </div>
                        <span>{t('column')}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              </div>
              <div
                className="main-body-main-table-wrap position-relative"
                style={{
                  maxWidth: "100%",
                  width: "100%",
                  overflow: "visible",
                }}
              >
                <div className="my-inventory-sticky-thead">
                  <div
                    className="my-inventory-table-hscroll my-inventory-table-hscroll--head"
                    ref={tableHeadScrollRef}
                    onScroll={() => syncInventoryTableScroll("head")}
                  >
                    <table
                      ref={tableHeadTableRef}
                      className="stripe row-border order-column common-table table-striped main-table my-inventory-head-table"
                    >
                      <Tablehead
                        tablehead={newcolumndata}
                        tblName={'tbl_sku_movement'}
                        setfilterby={""}
                        setShowoption={setSelectAllStatus}
                      />
                    </table>
                  </div>
                </div>
                <div
                  className="my-inventory-table-hscroll my-inventory-table-hscroll--body"
                  ref={tableBodyScrollRef}
                  onScroll={() => syncInventoryTableScroll("body")}
                >
                <table
                  id="sku_movement"
                  ref={tableBodyTableRef}
                  className="stripe row-border order-column common-table table-striped main-table"
                >
                  <tbody>
                    {/* Hide stale rows while loading so the table loader below shows in their place. */}
                    {skumovementlist && !datalodaer
                      ? skumovementlist.map((result, key) => {
                        return (
                          <tr key={key} className="">
                            <td className="">
                              <div className="com-check">
                                <input
                                  id={result?.id}
                                  data-id={result?.id}
                                  data-locationid={result?.location_id}
                                  className="inventoryskumovementtablecheck skumovementHead"
                                  onChange={selectedproduct}
                                  type="checkbox"
                                />
                                <label
                                  htmlFor={result?.id}
                                  className="com-check-label"
                                />
                              </div>
                            </td>
                            <td className="fixed-side">{key + 1}</td>
                            <td
                              className="table-pro-img fixed-side"
                              onClick={() => setImageid(result?.product_id)}
                              data-bs-toggle="modal"
                              data-bs-target="#ProductViewModal"
                            >
                              <img
                                src={
                                  result?.main_image
                                    ? result?.main_image
                                    : base_assets +
                                    'images/icon/camera_profile.png'
                                }
                                alt=""
                              />
                            </td>
                            <td
                              className="fixed-side link-color cursor-pointer"
                            >
                              <Link
                                to="/app/inventory/skuMovementdetails"
                                className="text-decoration-none"
                                state={{
                                  SKU: result?.SKU,
                                }}
                              >
                                {result?.SKU ? result?.SKU : ''}
                              </Link>
                            </td>
                            <td className="fixed-side">
                              {result?.metal_name ? result?.metal_name : ''}
                            </td>
                            <td className="fixed-side">
                              {result?.stone_name ? result?.stone_name : '-'}
                            </td>
                            <td className="fixed-side">
                              {result?.size_name ? result?.size_name : ''}
                            </td>
                            <td className="fixed-side">
                              {result?.item_name ? result?.item_name : ''}
                            </td>
                            <td className="fixed-side">
                              {result?.collection_name
                                ? result?.collection_name
                                : ''}
                            </td>
                            <td className="location-td fixed-side">
                              <span className="link-color">
                                {result?.locations ? result?.locations : ''}
                              </span>
                            </td>
                            <td className="fixed-side">
                              {result?.aging ? result?.aging : '0'}
                            </td>
                            <td className="fixed-side">
                              {result?.inward_Qty ? result?.inward_Qty : '-'}
                            </td>
                            <td className="fixed-side">
                              {result?.outward_Qty
                                ? result?.outward_Qty
                                : '-'}
                            </td>
                            <td className="fixed-side">
                              {result?.closing_Qty
                                ? result?.closing_Qty
                                : '-'}
                            </td>
                            <td className="fixed-side">
                              {result?.closing_amount
                                ? result?.closing_amount
                                : '-'}
                            </td>
                          </tr>
                        )
                      })
                      : ''}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                      <td />
                    </tr>
                  </tfoot>
                </table>
                </div>
                {datalodaer && <TableLoader />}
              </div>
            </div>
          </div>
        </div>
        {skumovementlist.length > 0 ? (
          <Pagination
            total={totalPages}
            current={currentPage}
            pagination={(crPage) => handlePaginations(crPage)}
          />
        ) : (
          []
        )}
        <SocialModal shareUrl={socialurl} shareloader={shareloader} />
        <ProductImageSliderModal main_id={imageid}></ProductImageSliderModal>
        <Filtermodal submitfiltter={getskumovement} limit={limit} custom_filter_enable={false} />
        <TableColumnModal
          tablehead={inventoryskumovementlisthead}
          tblName={'tbl_sku_movement'}
          setnewcolumndata={setnewcolumndata}
          calldatatable={getskumovement}
        ></TableColumnModal>
      </div>
    </React.Fragment>
  )
}
export default SkuMovement
